module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"btn-confirm":"Confirm"},"zh-TW":{"btn-confirm":"確認"}}')
  delete Component.options._Ctor
}
